import { useState } from "react";
import { GalleryWrapper } from "styles/jss/Layout.styles";
import NextImage from "../../NextImage";
import { getImageUrl } from "utils/helperFunction";
import GalleryLightBox from "../../GalleryLightBox";

export default function GallerySection({ images }) {
  const [index, setIndex] = useState(-1);

  const handle_renderThumbnail = item => {
    if (item.mime.includes("video")) {
      return (
        <div className={"videoThumb"}>
          <span className={"playIcon"} />
          <video>
            <source
              src={`${process.env.BASE_URL}${item.url}`}
              type="video/mp4"
            />
          </video>
        </div>
      );
    } else {
      const image = getImageUrl(item.formats, "medium");
      return (
        <div className="imageThumb">
          <NextImage
            layout={"responsive"}
            objectFit={"cover"}
            src={image?.url}
            alt={item.caption}
            width={283}
            height={190}
            placeholder="blur"
          />
        </div>
      );
    }
  };
  return (
    <GalleryWrapper>
      {images.map((item, index) => {
        return (
          <div key={item.id} onClick={() => setIndex(index)}>
            {handle_renderThumbnail(item.attributes)}
          </div>
        );
      })}

      <GalleryLightBox images={images} setIndex={setIndex} index={index} />
    </GalleryWrapper>
  );
}
